import { Controller } from '@hotwired/stimulus'

// Контроллер для сворачивания/разворачивания секций
export default class extends Controller {
  static targets = ['content', 'button']
  static values = {
    collapsed: { type: Boolean, default: true }
  }

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    this.updateVisibility()
  }

  updateVisibility() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle('hidden', this.collapsedValue)
    }

    if (this.hasButtonTarget) {
      const icon = this.buttonTarget.querySelector('svg')
      if (icon) {
        // Поворачиваем иконку стрелки
        icon.classList.toggle('rotate-180', !this.collapsedValue)
      }
    }
  }
}
